import PropTypes from 'prop-types';
import { AVAILABLE_ROLES } from '@projectMembers/models/projectRole';

const ProjectRolePropType = PropTypes.shape( {
	id: PropTypes.oneOf( AVAILABLE_ROLES.map( role => role.id ) ).isRequired,
	name: PropTypes.string.isRequired
} );

export default ProjectRolePropType;
